import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Address, isObjectEmpty } from 'clicklease-ui-elements';
import { PersonalInfoFormFeatureName } from './personal-info-form.reducer';
import {
    PersonalInformationFormState,
    WritablePersonalInformation,
} from './../../interfaces';

const getPersonalInfoFormState = (
    state: PersonalInformationFormState
): PersonalInformationFormState => state;

const getPersonalInfoForm = ({
    data,
}: PersonalInformationFormState): WritablePersonalInformation => data;

const getPersonalInfoFormEmpty = ({
    data,
}: PersonalInformationFormState): boolean => isObjectEmpty(data);

const getPersonalInfoFormIsSubmitting = ({
    isSubmitting,
}: PersonalInformationFormState): boolean => isSubmitting;

const getPersonalInfoFormIsSubmittingError = ({
    isSubmittingError,
}: PersonalInformationFormState): boolean => isSubmittingError;

const getPersonalInfoFormIsLoading = ({
    loading,
}: PersonalInformationFormState): boolean => loading;

const getPersonalInfoFormFirstName = ({
    data,
}: PersonalInformationFormState): string => data.firstName;

const getPersonalInfoFormLastName = ({
    data,
}: PersonalInformationFormState): string => data.lastName;

const getPersonalInfoFormPhone = ({
    data,
}: PersonalInformationFormState): string => data.phone;

const getPersonalInfoFormEmail = ({
    data,
}: PersonalInformationFormState): string => data.email;

const getPersonalInfoFormAddress = ({
    data,
}: PersonalInformationFormState): Address => data.address;

export const PersonalInfoFormFeatureSelector =
    createFeatureSelector<PersonalInformationFormState>(
        PersonalInfoFormFeatureName
    );

export const PersonalInfoFormStateSelector = createSelector(
    PersonalInfoFormFeatureSelector,
    getPersonalInfoFormState
);

export const PersonalInfoFormSelector = createSelector(
    PersonalInfoFormFeatureSelector,
    getPersonalInfoForm
);

export const PersonalInfoFormEmptySelector = createSelector(
    PersonalInfoFormFeatureSelector,
    getPersonalInfoFormEmpty
);

export const PersonalInfoFormIsSubmittingSelector = createSelector(
    PersonalInfoFormFeatureSelector,
    getPersonalInfoFormIsSubmitting
);

export const PersonalInfoFormIsSubmittingErrorSelector = createSelector(
    PersonalInfoFormFeatureSelector,
    getPersonalInfoFormIsSubmittingError
);

export const PersonalInfoFormIsLoadingSelector = createSelector(
    PersonalInfoFormFeatureSelector,
    getPersonalInfoFormIsLoading
);

export const PersonalInfoFormFirstNameSelector = createSelector(
    PersonalInfoFormFeatureSelector,
    getPersonalInfoFormFirstName
);

export const PersonalInfoFormLastNameSelector = createSelector(
    PersonalInfoFormFeatureSelector,
    getPersonalInfoFormLastName
);

export const PersonalInfoFormPhoneSelector = createSelector(
    PersonalInfoFormFeatureSelector,
    getPersonalInfoFormPhone
);

export const PersonalInfoFormEmailSelector = createSelector(
    PersonalInfoFormFeatureSelector,
    getPersonalInfoFormEmail
);

export const PersonalInfoFormAddressSelector = createSelector(
    PersonalInfoFormFeatureSelector,
    getPersonalInfoFormAddress
);
